export default "__VITE_ASSET__DjQ8Ltcq__"